'use strict';var makeClass = require('../utils/make-class');var _require = 
require('./hash');var Hash = _require.Hash;

var Hash256 = makeClass({ 
  inherits: Hash, 
  statics: { 
    width: 32, 
    init: function init() {
      this.ZERO_256 = new this(new Uint8Array(this.width));} } });




module.exports = { 
  Hash256: Hash256 };


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-hashes/node_modules/ripple-binary-codec/distrib/npm/types/hash-256.js
// module id = w73s
// module chunks = 0